<form [formGroup]="settingsForm" class="form-content" (ngSubmit)="onSubmitSettings()">
  <div class="form-group pt-2">
    <input type="checkbox" id="askManagerEnabled" formControlName="askManagerEnabled" />
    <label class="ps-1" for="askManagerEnabled">
      {{ 'Settings::AgentAssist:AskManagerEnabled' | abpLocalization }}
    </label>
    <div>
      <small class="text-muted">
        {{ 'Settings::AgentAssist:AskManagerEnabledDescription' | abpLocalization }}
      </small>
    </div>
  </div>
  <button type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
